import { Schema } from '.';

const fepSpot: Schema = [
  {
    name: 'USER_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'GROUP_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'LEGAL_ENTITY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'INGEST_ID',
    type: 'STRING',
    mode: 'REQUIRED',
    nomap: true,
  },
  {
    name: 'DELETED',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
    nomap: true,
  },
  {
    name: 'CCY_PAIR',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'CURRENCY_1',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'CURRENCY_2',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TENOR',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TENOR1',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TENOR2',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_DATETIME',
    type: 'TIMESTAMP',
    mode: 'REQUIRED',
  },
  {
    name: 'PRICE',
    type: 'FLOAT',
    mode: 'REQUIRED',
  },
  {
    name: 'SIDE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'NOTIONAL_AMOUNT',
    type: 'FLOAT',
    mode: 'REQUIRED',
  },
  {
    name: 'CONTRACT_TYPE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'INSTRUMENT_TYPE',
    type: 'STRING',
    mode: 'REQUIRED',
  },
  {
    name: 'SPOT_PRICE',
    type: 'INTEGER',
    mode: 'NULLABLE',
  },
  {
    name: 'MATURITY_DATE',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'VALUE_DATE',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'PRICE_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'FORWARD_POINTS',
    type: 'FLOAT64',
    mode: 'NULLABLE',
  },
  {
    name: 'NOTIONAL_ORDERED',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DEAL_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TIME_ZONE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'FORWARD_START_TENOR',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SPOT_DELAY',
    type: 'INTEGER',
    mode: 'NULLABLE',
  },
  {
    name: 'IS_DOMESTIC_VARIANT',
    type: 'BOOLEAN',
    mode: 'NULLABLE',
  },
  {
    name: 'IS_INTERNATIONAL_VARIANT',
    type: 'BOOLEAN',
    mode: 'NULLABLE',
  },
  {
    name: 'BENCHMARK',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'EXPLICIT_COST',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'SECURITY_SUBTYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DESCRIPTION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADE_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'TRADER',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'DESK_LOCATION',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'COVER_PRICE',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'LIMIT_PRICE',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'ORDER_SIZE',
    type: 'INTEGER',
    mode: 'NULLABLE',
  },
  {
    name: 'EVENT_TYPE',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'INSTRUCTIONS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'STATUS',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PM',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'ACCOUNT',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'FUND',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'STRATEGY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'COUNTERPARTY',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'PLATFORM',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'OTHER_ID',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    mode: 'NULLABLE',
    name: 'CONTRACT_ID',
    type: 'STRING',
  },
  {
    name: 'PORTFOLIO',
    type: 'STRING',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_1',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_2',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'INGEST_TIME',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_3',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_BENCHMARK_4',
    type: 'FLOAT',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_1',
    type: 'DATE',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_2',
    type: 'TIMESTAMP',
    mode: 'NULLABLE',
  },
  {
    name: 'CUSTOM_3',
    type: 'STRING',
    mode: 'NULLABLE',
  },
].sort((a, b) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
});

export default fepSpot;
